export const CHIFFRES_DIAGNOSTICS = {
  FRUITS: {
    production: "0.3%",
    consommation: "9%",
    importation: "80%",
  },
  LEGUMES: {
    production: "2%",
    consommation: "2%",
    importation: "15%",
  },
  ELEVAGE: {
    production: "70%",
    consommation: "45%",
    importation: "10%",
  },
  CEREALES: {
    production: "20%",
    consommation: "33%",
    importation: "70%",
  },
};

// consommation source:
